import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9f3c5750"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"text-align":"center"} }, "智能分析图表", -1))
const _hoisted_2 = { class: "stepsContent" }
const _hoisted_3 = {
  key: 0,
  class: "stepContent"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "请上传数据文件，文件格式是：.xlsx/.xls", -1))
const _hoisted_6 = {
  key: 1,
  class: "stepContent"
}
const _hoisted_7 = {
  key: 2,
  class: "stepContent"
}
const _hoisted_8 = {
  key: 3,
  class: "stepContent"
}
const _hoisted_9 = {
  key: 4,
  class: "stepContent"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "mainChart",
  style: {"width":"500px","height":"280px"}
}, null, -1))

import { computed, ref, watch, watchEffect } from "vue";
import {
  CHART_STATUS_ENUM,
  CHART_TYPE_BAR_ENUM,
  CHART_TYPE_LINE_ENUM,
  CHART_TYPE_PIE_ENUM,
  CHART_TYPE_SCATTER_ENUM,
} from "@/constant/chart";
import API from "@/api";
import {
  addChartByFileUsingPost,
  getChartVoByIdUsingGet,
} from "@/api/chartController";
import message from "@arco-design/web-vue/es/message";
import * as echarts from "echarts";
import { IconLeft, IconRight } from "@arco-design/web-vue/es/icon";
import {
  getDefaultRemainingCountUsingPost,
  getUserRemainingCountUsingPost,
} from "@/api/userUsageController";
import { useLoginUserStore } from "@/store/userStore";

const minStep = 1;
const maxStep = 5;

export default /*#__PURE__*/_defineComponent({
  __name: 'ChartPage',
  setup(__props) {

const form = ref<API.ChartAddRequest>({
  chartName: "",
  chartGoal: "",
  chartType: "",
});
const fileData = ref();
// 0-未生成 1-生成中 2-生成成功 3-生成失败
const isGenChart = ref(0);
const chartId = ref();
const chartData = ref<API.ChartVO>({});
let intervalChart: any;

const current = ref(1);
const isCanNext = ref([false, false, false, true, false]);

const onPrev = () => {
  current.value = Math.max(minStep, current.value - 1);
};

const onNext = () => {
  current.value = Math.min(maxStep, current.value + 1);
  if (current.value === 5) {
    chartData.value = {};
  }
};

const setCurrent = (cur: number) => {
  current.value = cur;
};

const fileInput = ref();

const handleInputClick = () => {
  fileInput.value.click();
};

const getFile = (event: any) => {
  fileData.value = event.target.files[0];
  isCanNext.value[current.value - 1] = true;
};

const handleChartTypeClick = (value: string) => {
  form.value.chartType = value;
  isCanNext.value[current.value - 1] = true;
};

watch([form.value], () => {
  if (form.value.chartName != "" && form.value.chartGoal != "") {
    isCanNext.value[current.value - 1] = true;
  }
});

const descData = ref([
  {
    label: "图表名称",
    value: computed(() => form.value.chartName),
  },
  {
    label: "图表目标",
    value: computed(() => form.value.chartGoal),
  },
  {
    label: "图表类型",
    value: computed(() => form.value.chartType),
  },
  {
    label: "上传文件",
    value: computed(() => fileData.value.name),
  },
]);

const handleSubmit = async () => {
  const res = await addChartByFileUsingPost(
    { ...form.value },
    {},
    fileData.value
  );
  if (res.data.code === 200) {
    getRemainingCount();
    chartId.value = res.data.data;
    isGenChart.value = 1;
    intervalChart = setInterval(() => {
      getChartData();
    }, 3000);
  } else {
    chartData.value = {};
    isGenChart.value = 3;
    message.error("生成图表失败，" + res.data.message);
  }
};

// 图表相关
const getChartData = async () => {
  if (!chartId.value) {
    return;
  }
  const res = await getChartVoByIdUsingGet({
    id: chartId.value as any,
  });
  if (res.data.code === 200) {
    if (res.data.data.chartStatus == CHART_STATUS_ENUM.SUCCESS) {
      clearInterval(intervalChart);
      chartData.value = res.data.data as any;
      chartChange();
    }
  } else {
    isGenChart.value = 3;
    message.error("获取数据失败，" + res.data.message);
  }
};

const chartChange = () => {
  var myChart = echarts.init(document.getElementById("mainChart"));
  // 绘制图表
  let validJsonString = chartData.value.genData.replace(/'/g, '"');
  myChart.setOption(JSON.parse(validJsonString));
  isGenChart.value = 2;
  message.success("生成图表成功");
};

const loginUserStore = useLoginUserStore();
const remainingCount = ref<number>(0);
/**
 * 获取剩余调用次数
 */
const getRemainingCount = async () => {
  if (!loginUserStore.loginUser.id) {
    const res = await getDefaultRemainingCountUsingPost({
      usageType: "chart_ai",
    });
    if (res.data.code === 200) {
      remainingCount.value = res.data.data as number;
    } else {
      message.error("获取调用次数失败，" + res.data.message);
    }
  } else {
    const res = await getUserRemainingCountUsingPost({
      usageType: "chart_ai",
    });
    if (res.data.code === 200) {
      remainingCount.value = res.data.data as number;
    } else {
      message.error("获取调用次数失败，" + res.data.message);
    }
  }
};

watchEffect(() => {
  getRemainingCount();
});

return (_ctx: any,_cache: any) => {
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_result = _resolveComponent("a-result")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { id: "chartPage" }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    extra: _withCtx(() => [
      _createTextVNode(" 剩余" + _toDisplayString(remainingCount.value) + "次机会 ", 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_steps, {
        changeable: false,
        current: current.value,
        onChange: setCurrent
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_step, null, {
            default: _withCtx(() => [
              _createTextVNode("导入图表数据")
            ]),
            _: 1
          }),
          _createVNode(_component_a_step, null, {
            default: _withCtx(() => [
              _createTextVNode("选择图表类型")
            ]),
            _: 1
          }),
          _createVNode(_component_a_step, null, {
            default: _withCtx(() => [
              _createTextVNode("填写图表信息")
            ]),
            _: 1
          }),
          _createVNode(_component_a_step, null, {
            default: _withCtx(() => [
              _createTextVNode("确认图表信息")
            ]),
            _: 1
          }),
          _createVNode(_component_a_step, null, {
            default: _withCtx(() => [
              _createTextVNode("导出图表数据")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["current"]),
      _createElementVNode("div", _hoisted_2, [
        (current.value === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_a_space, {
                direction: "vertical",
                fill: ""
              }, {
                default: _withCtx(() => [
                  (fileData.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, "已上传文件：" + _toDisplayString(fileData.value.name), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_button, {
                    onClick: handleInputClick,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 点击上传 "),
                      _createElementVNode("input", {
                        type: "file",
                        style: {"display":"none"},
                        ref_key: "fileInput",
                        ref: fileInput,
                        onChange: _cache[0] || (_cache[0] = ($event: any) => (getFile($event)))
                      }, null, 544)
                    ]),
                    _: 1
                  }),
                  _hoisted_5
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (current.value === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_a_space, { direction: "vertical" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_group, {
                    modelValue: form.value.chartType,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.chartType) = $event)),
                    type: "button",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CHART_TYPE_LINE_ENUM), (value, index) => {
                        return (_openBlock(), _createBlock(_component_a_radio, {
                          key: index,
                          value: value,
                          onClick: ($event: any) => (handleChartTypeClick(value))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(value), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_a_radio_group, {
                    modelValue: form.value.chartType,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.chartType) = $event)),
                    type: "button",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CHART_TYPE_BAR_ENUM), (value, index) => {
                        return (_openBlock(), _createBlock(_component_a_radio, {
                          key: index,
                          value: value,
                          onClick: ($event: any) => (handleChartTypeClick(value))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(value), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_a_radio_group, {
                    modelValue: form.value.chartType,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.chartType) = $event)),
                    type: "button",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CHART_TYPE_PIE_ENUM), (value, index) => {
                        return (_openBlock(), _createBlock(_component_a_radio, {
                          key: index,
                          value: value,
                          onClick: ($event: any) => (handleChartTypeClick(value))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(value), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_a_radio_group, {
                    modelValue: form.value.chartType,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.chartType) = $event)),
                    type: "button",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CHART_TYPE_SCATTER_ENUM), (value, index) => {
                        return (_openBlock(), _createBlock(_component_a_radio, {
                          key: index,
                          value: value,
                          onClick: ($event: any) => (handleChartTypeClick(value))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(value), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (current.value === 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_a_form, {
                model: form.value,
                class: "form",
                onSubmit: getChartData
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "图表名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        modelValue: form.value.chartName,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.chartName) = $event)),
                        placeholder: "请输入图表名称"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "图表目标" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        style: {"max-height":"200px"},
                        "max-length": { length: 300, errorOnly: true },
                        modelValue: form.value.chartGoal,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.chartGoal) = $event)),
                        placeholder: "请输入图表目标",
                        "auto-size": "",
                        "allow-clear": "",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]))
          : _createCommentVNode("", true),
        (current.value === 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_a_descriptions, {
                style: {"margin-top":"20px"},
                data: descData.value,
                size: "large",
                title: "图表数据",
                column: 1
              }, null, 8, ["data"])
            ]))
          : _createCommentVNode("", true),
        (current.value === 5)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_a_row, { style: {"height":"100%","margin-top":"30px"} }, {
                default: _withCtx(() => [
                  (isGenChart.value === 1)
                    ? (_openBlock(), _createBlock(_component_a_col, {
                        key: 0,
                        span: 24,
                        style: {"text-align":"center","margin-top":"100px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_spin, {
                            loading: isGenChart.value === 1,
                            tip: "生成中..."
                          }, null, 8, ["loading"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (isGenChart.value === 3)
                    ? (_openBlock(), _createBlock(_component_a_col, {
                        key: 1,
                        span: 24,
                        style: {"justify-content":"center","align-items":"center"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_result, {
                            status: "warning",
                            title: "生成失败"
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  (isGenChart.value === 2)
                    ? (_openBlock(), _createBlock(_component_a_col, {
                        key: 2,
                        span: 12
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_paragraph, { copyable: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(chartData.value.genResult), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_space, {
          class: "stepBtn",
          size: "large"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "secondary",
              disabled: current.value <= minStep,
              onClick: onPrev
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IconLeft)),
                _createTextVNode(" 上一步 ")
              ]),
              _: 1
            }, 8, ["disabled"]),
            (current.value === maxStep)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "outline",
                  onClick: handleSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("生成图表")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_button, {
              type: "primary",
              disabled: current.value >= maxStep || !isCanNext.value[current.value - 1],
              onClick: onNext
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 下一步 "),
                _createVNode(_unref(IconRight))
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})